import React from 'react'
import PostConfirmation from '../../components/Admin/PostConfirmation'

const AdminConfirmPage = () => {
  return <PostConfirmation />
}

export default AdminConfirmPage


